interface InfoCircleIconProps {
  className?: string;
  strokeWidth?: number;
}

export const InfoCircleIcon = ({ className = 'h-6 w-6', strokeWidth = 2 }: InfoCircleIconProps) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);
